import { Outlet } from 'react-router-dom';
import { FeatureGateName, NoContentCard } from '@geneo2-web/shared-ui';
import { useFeatureGate } from '../../utils/customHooks';

// Guards the Learning Homework route, so a direct URL is blocked too, not just
// the homework-card redirect.
export const LearningHomeworkGate = () => {
  const learningHomeworkEnabled = useFeatureGate(
    FeatureGateName.learningHomeworkEnabled
  );
  if (learningHomeworkEnabled) return <Outlet />;

  return (
    <NoContentCard
      variant="info"
      icon="cards"
      text="Learning Homework is not available for this school"
      textStyles={{ textAlign: 'center' }}
    />
  );
};
